<template>
    <div class="hitem">
      <div class="dte">
        {{ hitem.date }}
      </div>
      <div class="itm">
        <ul>
          <li v-for="(item, i) in splitText(hitem.item)" :key="i"> {{ item }} </li>
        </ul>
        <div class="icwrap" v-if="Object.keys(action.label).length !==0">
          <div v-for="(ic, i) in action.label" :key="i" v-html="ic" class="ic" 
            :title="action.action[i]" @click="iconClick(i)"></div>
        </div>
      </div>
      <div class="atn">
        By: {{ hitem.usr }}
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "HistoryItem",
    props:{
      hitem: Object,
      action:{
        type: Object,
        default: ()=>({label:{},action:{}}),
      }
    },
    setup(props, { emit }){
      function splitText(text) {
        if (typeof text !== 'string') {
          return [];
        }
        return text.split('&').map(item => item.trim());
      }
      function iconClick(i){emit(props.action.action[i],props.hitem)}
      return {splitText, iconClick}
    }
  };
  </script>
  
<style scoped>
  .hitem{    margin: 30px 0;
    border: 3px solid var(--data-table-border);
    border-radius: 30px;
    padding: 10px 20px; color:var(--black);
    position: relative;}
  .dte, .atn{    background: var(--primary-color);
    display: inline-block;
    padding: 5px 10px;
    border-radius: 20px;
    color: var(--always-white);
    font-weight: bold;
    font-size: 12px;
    position: relative;
    top: -16px;
    left: -26px;}
  .itm{margin-top: -12px;}
  ul{margin: 0; margin-bottom: 10px; padding: 5px 20px;}
  .atn{top: auto; left: auto; bottom: -11px;
    right: 1px;
    position: absolute;}
  .icwrap{display: flex; align-items: center; stroke: var(--black); padding:0 10px; margin-top: -5px;
    margin-bottom: 5px; gap:5px}
  .icwrap .ic{width:20px; height:20px; cursor: pointer;}
</style>
  